// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const COMMON_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  NAME: 'common.view.name',
  TITLEBAR_VISIBILITY: 'common.view.titlebar.visible',
  BACKGROUND_COLOR: 'common.view.background.color',
  BACKGROUND_COLOR_OPACITY: 'common.view.background.color.opacity',
  DESCRIPTION: 'common.view.description',
  DESCRIPTION_SHOW_ATTRIBUTES: 'common.view.description.show.attributes',
  DESCRIPTION_SHOW_DESCRIPTION: 'common.view.description.show.description',
  INFO_WINDOW: 'common.view.infowindow',
  MEDIA_REPOSITORY_NAME: 'common.view.media.repositoryName',
  MEDIA_CONTENT_IDENTIFIER: 'common.view.media.contentIdentifier',
  MEDIA_SIGNATURE: 'common.view.media.signature',
  INTEGRATED: 'common.view.integrated',
  LINEAR_LAYOUT_ORDER: 'common.view.linear-layout.order',
  LINEAR_LAYOUT_VISIBLE: 'common.view.linear-layout.visible'
} as const;

/** @see net/disy/cadenza/workbook/model/CommonViewSettingsKey.java */
export type CommonViewSettingsKey = keyof typeof COMMON_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const CommonViewSettingsKey = {
  values: Object.keys(COMMON_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly CommonViewSettingsKey[],
  toPersistenceKey: (value: CommonViewSettingsKey) => COMMON_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = CommonViewSettingsKey.values.find(key => COMMON_VIEW_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No CommonViewSettingsKey for key: ${persistenceKey}`); }
    return value;
  },
} as const;

// </GENERATED-CODE>
